import React, { Component } from 'react';
import {
	Table,
	TableHead,
	TableRow,
	TableBody,
	TableCell,
    IconButton,
    CircularProgress
} from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputAdornment from '@mui/material/InputAdornment';
import SimpleReactValidator from "simple-react-validator";
import { creditCategoryService } from '../../../service/settings/manage/credit_category.service.js';
import { currencyTypeService } from '../../../service/settings/manage/currency_type.service.js';
import { creditPriceService } from '../../../service/settings/manage/credit_price.service.js';
import { assessmentService } from "../../../service/assessment/assessmentService";
import { Spinner } from 'react-bootstrap';
import { sweetErrorAlert, sweetStatusAlert, sweetSuccessAlert } from '../../../components/common/SweetAlert.js';
import ContentWrapper from '../../../components/common/ContentWrapper.js';
import config from '../../../helper/config.js';
import { customerConstants, grades } from "../../../helper/constants.js";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import sweetAlert, { sweetConfirmAlert } from "../../../components/common/SweetAlert.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box } from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import Checkbox from "@mui/material/Checkbox";
import { CREDIT_CATEGORY_FILTERS } from "../../../helper/constants";
import CheckBoxInline from "../../../components/common/form/CheckBoxInline.js";
import CheckBox from "../../../components/common/form/CheckBox.js";
import moment from "moment-timezone";
import ModalBody from "../../../components/common/modal/ModalBody";
import ModalHeader from "../../../components/common/modal/ModalHeader";
import ViewForm from "../../../components/common/form/Form";
import { appConfigConstants } from '../../../helper/constants.js';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from '../../manage/paper/edsider/TheFilter/PaperFilterLayout.js';
import { EMPLOYEE_FILTERS } from '../../../helper/constants.js';



const getCustomerFeatureFlag = () => {
	return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
	case customerConstants.EXO_CUSTOMER1:
		break
	case customerConstants.EXO_CUSTOMER2:
		closeBtnStyle = {
			color: "var(--maincolor-cmc)",
			backgroundColor: "#E5F5FF",
			borderColor: "transparent"
		}
		addBtnStyle = {
			color: "#fff",
			backgroundColor: "var(--maincolor-cmc)",
			borderColor: "transparent"
		}
		break
	default:
		break
}

class ManageCreditCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading: false,
      credit_category_id: "",
      grade_id: "",
      subject_id: "",
      language_id: "",
      exam_category_id: "",
      purchase_method_id: "",
      status_id: "",
      price: "",
      price_currency_type_id: 1,
      status: "",
      start_date: "",
      end_date: null,
      user_type_id: null,
      credit_categories: [],
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allYears: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allPrivileges: [],
      allAssessmentStatuses: [],
      allExamCategories: [],
      allPurchaseMethods: [],
      gradeCounts: [],
      subjectCounts: [],
      languageCounts: [],
      examCategoryCounts: [],
      allCreditCategoryStatuses: [],
      allAppConfigs: [],
      limit: 10, 
      offset: 0, 
      search_term: "",
      sort_column: "credit_category_id",
      sort_direction: "ASC",
      totalCreditCategories: 10,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      currencyTypes: [],
      creditPrices: [],
      filterValues: [],
      filters: [],
      selectedGrades: null,
      selectedSubjects:null,
      selectedLanguages: null,
      selectedExamCategories: null,
      no_of_credits_error: "",
      child_paper_credits_error: "",
      price_error: "",
      disabled: false,
      one_credit_price: "",
      noEndDate: false,
      valid_credit: true,
      valid_price: true,
      valid_end_date: true,
      totalCredits:0,
      has_child_paper_credits: false,
      child_paper_credits: "",
    };
    this.validator = new SimpleReactValidator();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllCreditCategories, 2000);
  }

  resetFormFields = () => {
      this.setState({
        credit_category_id: "",
        grade_id: "",
        subject_id: "",
        language_id: "",
        exam_category_id: "",
        start_date: "",
        end_date: "",
        status: "",
        no_of_credits: "",
        price: "",
        price_currency_type_id: 1,
        purchase_method_id: "",
        status_id: "",
        noEndDate: false,
        has_child_paper_credits: false,
        child_paper_credits: "",
        disabled: false,
        valid_credit: true,
        valid_price: true,
        valid_end_date: true,
        no_of_credits_error: "",
        child_paper_credits_error: "",
        price_error: "",
        endDateError: "",
        isSpinnerLoading: false,
    });
  };

	componentDidMount() {
		this.fetchAllAssessmentMetaData();
		this.getAllCurrencyTypes();
		this.getAllCreditPrices();
		this.fetchAllCreditCategories();
	}

	getAllCurrencyTypes = async () => {
		this.setState({ isTableDataLoading: true });
		await currencyTypeService.getAllCurrencyTypes()
			.then((response) => {
				if (response.success) {
					this.setState({
						currencyTypes: response.data.currency_types
					});
				} else {
					sweetStatusAlert(
						"Failed!",
						"Error fetching currency types. Please refresh the screen!",
						"error"
					);
				}
			})
			.catch((error) => {
				sweetStatusAlert(
					"Failed!",
					"Error fetching currency types. Please refresh the screen!",
					"error"
				);
			})
			.finally(() => {
				this.setState({ isSpinnerLoading: false });
			});
	}

    getAllCreditPrices = async() => {
        this.setState({ isTableDataLoading: true });
        await creditPriceService.getAllCreditPrices()
        .then((response) => {
            if (response.success) {
            this.setState({
                creditPrices: response.data
            },() => {
                const credit_price = this.state?.creditPrices?.find(
                    (credit_price) => credit_price?.currency_type_id == parseInt(this.state.price_currency_type_id)
                );
                this.setState({ one_credit_price: credit_price?.one_credit_price });
            });
            } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching credit prices. Please refresh the screen!",
                "error"
            );
            }
        })
        .catch((error) => {
            sweetStatusAlert(
            "Failed!",
            "Error fetching credit prices. Please refresh the screen!",
            "error"
            );
        })
        .finally(() => {
            this.setState({ isSpinnerLoading: false });
        });
    }

	getCurrencyTypeName(currency_type_id) {
		if (currency_type_id !== null) {
			const currency_type = this.state.currencyTypes?.find(
				(currency_type) => currency_type.currency_type_id == currency_type_id
			);
			return currency_type?.name;
		}
		else {
			return "N/A";
		}
	}

  getCurrencyTypeSymbol(currency_type_id) {
    if (currency_type_id !== null) {
        const currency_type = this.state.currencyTypes?.find(
            (currency_type) => currency_type.currency_type_id == parseInt(currency_type_id)
        );
        return currency_type?.symbol;
    }
    else{
        return "N/A";
    }
  }

  getAppConfigValue(Name) {
    if (Name !== null) {
        const appConfig = this.state.allAppConfigs?.find(
            (appConfig) => appConfig.Name == Name  && appConfig.Status === 1
        );
        return parseInt(appConfig?.Value);
    }
    else{
        return "N/A";
    }
  }

  getStatusName(status_id) {
    if (status_id !== null) {
        const status = this.state.allCreditCategoryStatuses?.find(
            (status) => status.status_id == parseInt(status_id)
        );
        return status?.status;
    }
    else{
        return "N/A";
    }
  }

	fetchAllAssessmentMetaData = async () => {
		this.setState({
			isTableDataLoading: true,
		});

		const fetchAssessmentMetaData =
			await assessmentService.getAllAssessmentMetaData();

		await Promise.all([fetchAssessmentMetaData])
			.then((response) => {
				const [assessmentMetaDataResponse] = response;

        this.setState({
          allCategories: assessmentMetaDataResponse.data.find(
            (item) => "categories" in item
          ).categories,
          allLanguages: assessmentMetaDataResponse.data.find(
            (item) => "languages" in item
          ).languages,
          allSubjects: assessmentMetaDataResponse.data.find(
            (item) => "subjects" in item
          ).subjects,
          allAuthors: assessmentMetaDataResponse.data.find(
            (item) => "authors" in item
          ).authors,
          allYears: assessmentMetaDataResponse.data.find(
            (item) => "years" in item
          ).years,
          allDifficulties: assessmentMetaDataResponse.data.find(
            (item) => "difficulty_types" in item
          ).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find(
            (item) => "grades" in item
          ).grades,
          allTerms: assessmentMetaDataResponse.data.find(
            (item) => "terms" in item
          ).terms,
          allChapters: assessmentMetaDataResponse.data.find(
            (item) => "chapters" in item
          ).chapters,
          allPrivileges: assessmentMetaDataResponse.data.find(
            (item) => "privileges" in item
          ).privileges,
          allAssessmentStatuses: assessmentMetaDataResponse.data.find(
            (item) => "statuses" in item
          ).statuses,
          allExamCategories: assessmentMetaDataResponse.data.find(
            (item) => "exam_categories" in item
          ).exam_categories,
          allPurchaseMethods: assessmentMetaDataResponse.data.find(
            (item) => "purchase_methods" in item
          ).purchase_methods,
          allCreditCategoryStatuses: assessmentMetaDataResponse.data.find(
            (item) => "credit_category_statuses" in item
          ).credit_category_statuses,
          allAppConfigs: assessmentMetaDataResponse.data.find(
            (item) => "app_configs" in item
          ).app_configs,
          isSpinnerLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isSpinnerLoading: false,
        });
      });
  }

	fetchAllCreditCategories = async () => {
		this.setState({ isTableDataLoading: true });
		const {
			limit,
			offset,
			search_term,
			sort_column,
			sort_direction,
			selectedGrades,
			selectedSubjects,
			selectedLanguages,
			selectedExamCategories,
            totalCredits
		} = this.state;
		await creditCategoryService.getAll(
			limit,
			offset,
			search_term,
			sort_column,
			sort_direction,
			selectedGrades,
			selectedSubjects,
			selectedLanguages,
			selectedExamCategories,
		)
			.then((response) => {
				if (response.success) {
                 const totalCredits=response.data.credit_categories.reduce((sum, noOfCreditcats) => {
                        const n = Number(noOfCreditcats.no_of_credits ?? 0);
                        return sum + (Number.isFinite(n) ? n : 0);
                    }, 0);
					this.setState({
						credit_categories: response.data.credit_categories,
						totalCreditCategories: parseInt(response.data.total_count),
						gradeCounts: response.data.grade_counts,
						subjectCounts: response.data.subject_counts,
						languageCounts: response.data.language_counts,
						examCategoryCounts: response.data.exam_category_counts,
                        totalCredits
					});
				} else {
					sweetStatusAlert(
						"Failed!",
						"Error fetching Credit Categories. Please refresh the screen!",
						"error"
					);
				}
			})
			.catch((error) => {
				sweetStatusAlert(
					"Failed!",
					"Error fetching Credit Categories. Please refresh the screen!",
					"error"
				);
			})
			.finally(() => {
				this.setState({ isSpinnerLoading: false, isTableDataLoading: false });
			});
	}

	handlePageChange = (event, newPage) => {
		const { limit } = this.state;
		const newOffset = newPage * limit;
		this.setState(
			{
				offset: newOffset,
				isTableDataLoading: true,
				currentPage: newPage,
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	handleSortChange = (sort_column) => {
		// If the same column is clicked, toggle the sort direction
		const { sort_column: currentSortColumn, sort_direction } = this.state;
		const newSortDirection =
			currentSortColumn === sort_column && sort_direction === "ASC"
				? "DESC"
				: "ASC";

		this.setState(
			{
				sort_column,
				sort_direction: newSortDirection,
				offset: 0, // Reset offset when changing sorting
				currentPage: 0,
				isTableDataLoading: true,
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	handlePageOffsetChange = (newOffset, newPage) => {
		this.setState(
			{
				offset: newOffset,
				isTableDataLoading: true,
				currentPage: newPage
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	handleRowsPerPageChange = (event) => {
		const newLimit = parseInt(event.target.value, 10);
		const newPage = Math.floor(this.state.offset / newLimit);
		this.setState(
			{
				limit: newLimit,
				offset: newLimit * newPage,
				isTableDataLoading: true,
				currentPage: newPage,
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	handleSearch = (event) => {
            const search_term = event.target.value.trim();
            const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

        if (search_term === "" || regex.test(search_term)) {
        this.setState(
            {
            search_term,
            // isTableDataLoading: true,
            offset: 0,
            currentPage: 0,
            searchError: false,
            },
            () => {
            // this.debouncedHandleSearch();
            }
        );
        } else {
        this.setState({ search_term, searchError: true });
        }
    };

    handleViewClick = (creditCategoryItem) => {
        this.setState({
            selectedCreditCategory: creditCategoryItem, 
            showDetailModal: true,  
        });
    };

    getColor(status) {
        switch (status) {
            case "Active":
                return "label label-lg label-success label-inline";
            case "Deactive":
                return "label label-lg label-light-danger label-inline";
            default:
                return "label label-lg label-light-info label-inline";
        }
    }
    
    toggleDetailModal = () => {
        this.setState((prevState) => ({
            showDetailModal: !prevState.showDetailModal,
        }));
    };

    toggleCreditCategoryModal = (modalType) => {
        this.modalType = modalType;
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }));
    };

    toggleUpdateCreditCategoryModal = (credit_category_id, grade_id, subject_id, language_id, exam_category_id, purchase_method_id, status_id, no_of_credits, has_child_paper_credits, child_paper_credits, price, price_currency_type_id, status, start_date, end_date, modalType) => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            credit_category_id: credit_category_id,
            no_of_credits: no_of_credits === 0 ? "" : no_of_credits,
            has_child_paper_credits: has_child_paper_credits,
            child_paper_credits: has_child_paper_credits ? child_paper_credits : 0,
            grade_id: grade_id,
            subject_id: subject_id,
            language_id: language_id,
            exam_category_id: exam_category_id,
            price: price === "0.0" ? "" : price,
            price_currency_type_id: price_currency_type_id,
            status: status,
            purchase_method_id: purchase_method_id,
            status_id: status_id,
            start_date: start_date,
            end_date: end_date,
            noEndDate: end_date !== null && end_date !== "",
            modalType: modalType,
            disabled: false,
            valid_credit: true,
            valid_price: true,
            valid_end_date: true,
            no_of_credits_error: "",
            child_paper_credits_error: "",
            price_error: "",
            endDateError: "",
        }));
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        let error = '', price_error = '', endDateError = '';
        let { valid_credit, valid_price, valid_end_date } = this.state; // <-- track all validation flags from state
    
        if (name === "no_of_credits" || name === "child_paper_credits") {
            const noOfCreditsValue = parseInt(value);
            const minCredits = this.getAppConfigValue(appConfigConstants.MINIMUM_CREDIT_ASSESSMENT_LIMIT);
            const maxCredits = this.getAppConfigValue(appConfigConstants.MAXIMUM_CREDIT_ASSESSMENT_LIMIT);
    
            if (noOfCreditsValue < minCredits || noOfCreditsValue > maxCredits) {
                error = `no of credits must be between ${minCredits} and ${maxCredits}.`;
                valid_credit = false;
            } else {
                valid_credit = true;
            }
        }
    
        if (name === "price") {
            const priceValue = parseInt(value);
            const minPrice = this.getAppConfigValue(appConfigConstants.MINIMUM_PRICE_ASSESSMENT_LIMIT);
            const maxPrice = this.getAppConfigValue(appConfigConstants.MAXIMUM_PRICE_ASSESSMENT_LIMIT);
    
            if (priceValue < minPrice || priceValue > maxPrice) {
                price_error = `price must be between ${minPrice} and ${maxPrice}.`;
                valid_price = false;
            } else {
                valid_price = true;
            }
        }
    
        if (name === "end_date") {
            const startDate = new Date(this.state.start_date);
            const endDate = new Date(value);
            if (endDate < startDate) {
                endDateError = "End date cannot be earlier than start date.";
                valid_end_date = false;
            } else {
                valid_end_date = true;
            }
        }
    
        this.setState((prevState) => ({
            [name]: value,
            isModified: true,
            no_of_credits_error: name === "no_of_credits" ? error : prevState.no_of_credits_error,
            child_paper_credits_error: name === "child_paper_credits" ? error : prevState.child_paper_credits_error,
            price_error: name === "price" ? price_error : prevState.price_error,
            endDateError: name === "end_date" ? endDateError : prevState.endDateError,
            valid_credit,
            valid_price,
            valid_end_date,
            disabled: !(valid_credit && valid_price && valid_end_date),
        }));
    };

	handleChangeGrade = (event) => {
		event.preventDefault();
		this.setState({ grade_id: event.target.value });
	};

	handleChangeSubject = (event) => {
		event.preventDefault();
		this.setState({ subject_id: event.target.value });
	};

	handleChangeLanguage = (event) => {
		event.preventDefault();
		this.setState({ language_id: event.target.value });
	};

    handleChangeExamCategory = (event) => {
        event.preventDefault();
        this.setState({ exam_category_id: event.target.value });
    };

    handleChangePurchaseMethod = (event) => {
        event.preventDefault();
        this.setState({ purchase_method_id: event.target.value });
        if(parseInt(event.target.value, 10) === 1 && parseFloat(this.state.price) === "0.0"){
            this.setState({ price: "" })
        }
        if(parseInt(event.target.value, 10) === 2 && parseInt(this.state.no_of_credits) === 0){
            this.setState({ no_of_credits: "" })
        }
    };

    handleChangeStatus = (event) => {
        event.preventDefault();
        this.setState({ status_id: event.target.value },() => {
            this.setState({ status: this.getStatusName(this.state.status_id) });
        });
    };

    handleChangeCurrencyType = (event) => {
        event.preventDefault();
        this.setState({ price_currency_type_id: event.target.value });
    };

    convertTimeLevel(utcDateString) {
        const userTimeZone = moment.tz.guess();
        const convertedDate = moment(utcDateString).tz(userTimeZone);
        const formattedDate = convertedDate.format("MMMM D, YYYY h:mm:ss a");
        return formattedDate;
    }

    formatDateForInput = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    noEndDateSelected = (e, status) => {
        this.setState((prevState) => ({
            noEndDate: status,
            end_date: "",
            valid_end_date: true,
            endDateError: "",
            disabled: !(prevState.valid_credit && prevState.valid_price),
        }), () => {
            if (!status) {
                this.validator.purgeFields();
                this.forceUpdate();
            }
        });
    };

	handleSweetAlert = (modalType, modalVisibility) => {
		if (this.state.isModified) {
			sweetAlert().then((response) => {
				this.validator.hideMessages();
				this.validator.purgeFields();
				this.resetFormFields();
				this.modalType = false;
				this.setState(() => ({
					[modalVisibility]: response,
					isModified: false,
				}));
			});
		} else {
			this.validator.hideMessages();
			this.validator.purgeFields();
			this.resetFormFields();
			if (modalType) this.toggleCreditCategoryModal(false);
			else this.toggleUpdateCreditCategoryModal();
		}
	};

	//Handle Edit Submit
	handleEditSubmit = (event) => {
		event.preventDefault();

        if (
            this.state.has_child_paper_credits &&
            !this.state.child_paper_credits
        ) {
            this.validator.showMessageFor("child_paper_credits");
            this.forceUpdate();
            return;
        }
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        } 
        else 
        {
            this.setState({ isSpinnerLoading: true });
            const creditCategoryItem = {
                grade_id: this.state.grade_id,
                no_of_credits: parseInt(this.state.purchase_method_id) === 2 ? 0 : this.state.no_of_credits,
                has_child_paper_credits: this.state.has_child_paper_credits,
                child_paper_credits: this.state.has_child_paper_credits ? this.state.child_paper_credits : 0,
                price: parseInt(this.state.purchase_method_id) === 1 ? "0.0" : this.state.price,
                subject_id: this.state.subject_id,
                language_id: this.state.language_id,
                exam_category_id: this.state.exam_category_id,
                price_currency_type_id: parseInt(this.state.price_currency_type_id),
                status: this.state.status,
                purchase_method_id: this.state.purchase_method_id,
                status_id: parseInt(this.state.status_id),
                start_date: this.state.start_date,
                end_date: this.state.end_date ? this.state.end_date : null,
            };
            const creditCategoryId = this.state.credit_category_id;

            creditCategoryService.updateCreditCategory(creditCategoryItem, creditCategoryId)
                .then((response) => {
                if (response.success) {
                    this.setState({ isSpinnerLoading: false });
                    this.toggleCreditCategoryModal();
                    sweetStatusAlert(
                        "Success!",
                        "Credit category information updated successfully!",
                        "success"
                    );
                    this.validator.hideMessages();
                    this.validator.purgeFields();
                    this.resetFormFields();
                    this.fetchAllCreditCategories();
                }else {
                    this.setState({ isSpinnerLoading: false });
                    sweetStatusAlert("Failed!", response.message.error, "error");
                }
                })
                .catch((error) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert(
                    "Failed!",
                    "Unable to update the CreditCategory information",
                    "error"
                );
                });
        }
    };

	//add new credit category
	handleSubmit = (event) => {
		event.preventDefault();

        if (
            this.state.has_child_paper_credits &&
            !this.state.child_paper_credits
        ) {
            this.validator.showMessageFor("child_paper_credits");
            this.forceUpdate();
            return;
        }
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        } 
        else 
        {
            this.setState({ isSpinnerLoading: true });
            const newCreditCategory = {
            grade_id: this.state.grade_id,
            no_of_credits: parseInt(this.state.purchase_method_id) === 2 ? 0 : this.state.no_of_credits,
            has_child_paper_credits: this.state.has_child_paper_credits,
            child_paper_credits: this.state.has_child_paper_credits ? this.state.child_paper_credits : 0,
            price: parseInt(this.state.purchase_method_id) === 1 ? "0.0" : this.state.price,
            subject_id: this.state.subject_id,
            language_id: this.state.language_id,
            exam_category_id: this.state.exam_category_id,
            price_currency_type_id: parseInt(this.state.price_currency_type_id),
            status: this.state.status,
            purchase_method_id: this.state.purchase_method_id,
            status_id: parseInt(this.state.status_id),
            start_date: this.state.start_date,
            end_date: this.state.end_date ? this.state.end_date : null,
            };

                creditCategoryService.addCreditCategory(newCreditCategory)
                    .then((response) => {
                        if (response.success) {
                            sweetStatusAlert("Success!", response.message.success, "success");
                            this.validator.hideMessages();
                            this.validator.purgeFields();
                            this.resetFormFields();
                            this.toggleCreditCategoryModal(false);
                            this.fetchAllCreditCategories();
                        } else {
                            this.setState({ isSpinnerLoading: false });
                            sweetStatusAlert("Failed!", response.message.error, "error");
                        }
                    })
                    .catch((err) => {
                        this.setState({ isSpinnerLoading: false });
                        sweetStatusAlert("Failed!", "Unable to create new credit category", "error");
                    });
            }
        };
    handleFilterChange = (newSelectedFilters) => {    
        

        const getOrNull = (key) =>
        newSelectedFilters[key] && newSelectedFilters[key].length > 0
            ? newSelectedFilters[key]
            : null;

        this.setState(
        {
    
        selectedCategories: getOrNull("Category"),
        selectedAuthors: getOrNull("Author"),
        selectedChapters: getOrNull("Chapter"),
        selectedGrades: getOrNull("Grade"),
        selectedDifficulties: getOrNull("Difficulty"),
        selectedLanguages: getOrNull("Language"),
        selectedTerms: getOrNull("Term"),
        selectedYears: getOrNull("Year"),
        selectedSubjects: getOrNull("Subject"),
        selectedStatuses: getOrNull("Status"),
        selectedExamCategories: getOrNull("Exam_Category"),
        selectedSources: getOrNull("Source"),
        selectedCreators:getOrNull("Created_By"),
        selectedStartDate:getOrNull("StartDate"),
        selectedEndDate:getOrNull("EndDate"),

        offset: 0,
        currentPage: 0,
    
        },
        () => {
            this.fetchAllCreditCategories();
        }
        );
    };

	handleDeleteCreditCategory = (credit_category_id) => {
		sweetConfirmAlert().then(() => {
			this.setState({ isSpinnerLoading: true });
			creditCategoryService.deleteCreditCategory(credit_category_id)
				.then((response) => {
					if (response.success) {
						sweetStatusAlert("Success!", response.message.success, "success");
						this.fetchAllCreditCategories();
						this.setState({ isSpinnerLoading: false });
					} else {
						sweetStatusAlert("Failed!", response.message, "error");
						this.setState({ isSpinnerLoading: false });
					}
				})
				.catch((error) => {
					sweetStatusAlert("Oops!", "Error while deleting the credit category", "info");
					this.setState({ isSpinnerLoading: false });
				});
		});
	};

	onSelectFilterMulti = (selectedItem) => {

		const { filterValues } = this.state;

		let updatedFilterValues = [...filterValues];

		const index = updatedFilterValues.findIndex(
			(item) =>
				item.filter === selectedItem.filter &&
				item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
		);


		if (index === -1) {

			updatedFilterValues.push(selectedItem);

		} else {

			updatedFilterValues.splice(index, 1);
		}


		this.onSelectFilterMultiProcess(updatedFilterValues);
	};

	onSelectFilterMultiProcess = (filterValues) => {

		const filterMap = {
			Grade: [],
			Subject: [],
			Language: [],
			Exam_Category: [],
		};

		filterValues.forEach((val) => {
			const filterType = val.filter;
			if (filterType && filterMap.hasOwnProperty(filterType)) {
				switch (filterType) {
					case "Exam_Category":
						filterMap.Exam_Category.push(val?.exam_category_id);
						break;
					case "Grade":
						filterMap.Grade.push(val?.grade_id);
						break;
					case "Language":
						filterMap.Language.push(val?.language_id);
						break;
					case "Subject":
						filterMap.Subject.push(val?.subject_id);
						break;
					default:
						break;
				}
			}
		});

		this.setState(
			{
				filterValues,
				selectedSubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
				selectedLanguages: filterMap.Language.length > 0 ? filterMap.Language : null,
				selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
				selectedExamCategories: filterMap.Exam_Category.length > 0 ? filterMap.Exam_Category : null,
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	isParentChecked = (filterType) => {
		const filterValues = this.state.filterValues;
		const childItems = this.getChildItems(filterType);
		return (
			childItems.length > 0 &&
			childItems.every((child) =>
				filterValues.some(
					(selectedItem) =>
						selectedItem.filter === filterType &&
						selectedItem[`${filterType.toLowerCase()}_id`] ===
						child[`${filterType.toLowerCase()}_id`]
				)
			)
		);
	};

	isParentIndeterminate = (filterType) => {
		const filterValues = this.state.filterValues;
		const childItems = this.getChildItems(filterType);
		const selectedCount = childItems.filter((child) =>
			filterValues.some(
				(selectedItem) =>
					selectedItem.filter === filterType &&
					selectedItem[`${filterType.toLowerCase()}_id`] ===
					child[`${filterType.toLowerCase()}_id`]
			)
		).length;
		return selectedCount > 0 && selectedCount < childItems.length;
	};

	handleParentCheckboxChange = (filterType, filterItems) => {
		const filterValues = [...this.state.filterValues];
		const childItems = filterItems

		const allSelected = this.isParentChecked(filterType);


		let updatedFilterValues;
		if (allSelected) {

			updatedFilterValues = filterValues.filter(
				(item) => item.filter !== filterType
			);
		} else {

			const newSelections = childItems.map((child) => ({
				filter: filterType,
				name: child.name,
				[`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
			}));
			updatedFilterValues = [
				...filterValues.filter((item) => item.filter !== filterType),
				...newSelections,
			];
		}


		this.onSelectFilterMultiProcess(updatedFilterValues);
	};

	getChildItems = (filterType) => {
		switch (filterType) {
			case "Exam_Category":
				return this.state.allExamCategories || [];
			case "Grade":
				return this.state.allGrades || [];
			case "Language":
				return this.state.allLanguages || [];
			case "Subject":
				return this.state.allSubjects || [];
			default:
				return [];
		}
	};

	clearAllFilters = () => {
		this.setState(
			{
				filterValues: [],
				selectedSubjects: null,
				selectedLanguages: null,
				selectedGrades: null,
				selectedExamCategories: null,
			},
			() => {
				this.fetchAllCreditCategories();
			}
		);
	};

	render() {
		const {
			limit,
			credit_categories,
			totalCreditCategories,
			gradeCounts,
			subjectCounts,
			languageCounts,
			examCategoryCounts,
			isTableDataLoading,
			currentPage,
			isSpinnerLoading,
			editVisibility,
			addVisibility,
			deleteVisibility,
		} = this.state;
		return (
			<>
				<ContentWrapper>
					<div className="row justify-content-between align-items-center py-5 mb-3">
						<div className="col-md-6 col-6">
							<h3 className="text-nowrap">Manage Credit Categories</h3>
						</div>
						<div className="col-md-6 col-6 d-flex justify-content-end">
							{addVisibility && (
								<Button
									className="insert-btn"
									variant="primary"
									onClick={() => this.toggleCreditCategoryModal(true)}
								>
									Add Credit Category
								</Button>
							)}
						</div>
					</div>
					{/* <div className="row align-items-center">
						<div className="col-md-12 px-0 filterBySec">
							<Accordion className="filterAccordion">
								<AccordionSummary className="filterAccordionSummary" aria-controls="panel1-content" id="panel1-header">
									<Box
										sx={{ display: "flex", alignItems: "center", gap: "16px" }}
									>
										<div className="filterpprs mr-1">
											<TuneRoundedIcon />
											&emsp;Filter&emsp;
											<KeyboardArrowDownIcon
												sx={{
													transition: "transform 0.3s ease",
													cursor: "pointer",
												}}
												onClick={(e) => { }}
											/>
										</div>
									</Box>
								</AccordionSummary>
								<Box className="filterCardContainer" sx={{ overflowX: "auto", whiteSpace: "nowrap", display: "flex", padding: "8px", height: 'max-content', maxWidth: '80vw' }}>

									{CREDIT_CATEGORY_FILTERS.filter((category) => {

										return ["Grade", "Subject", "Language", "Exam_Category"].includes(category);

									}).map((category, index) => {

										let filterItems = [];

										if (category === "Grade") {
											const gradeCountsMap = new Map(gradeCounts.map(([grade_id, count]) => [grade_id, count]));
											filterItems = this.state.allGrades?.map((val) => ({
												filter: "Grade",
												name: val.grade,
												grade_id: val.grade_id,
												dynamic_count: gradeCountsMap.get(val.grade_id) || 0,
											}));
										} else if (category === "Subject") {
											const subjectCountsMap = new Map(subjectCounts.map(([subject_id, count]) => [subject_id, count]));
											filterItems = this.state.allSubjects?.map((val) => ({
												filter: "Subject",
												name: val.subject,
												subject_id: val.subject_id,
												dynamic_count: subjectCountsMap.get(val.subject_id) || 0,
											}));
										} else if (category === "Language") {
											const languageCountsMap = new Map(languageCounts.map(([language_id, count]) => [language_id, count]));
											filterItems = this.state.allLanguages?.map((val) => ({
												filter: "Language",
												name: val.language,
												language_id: val.language_id,
												dynamic_count: languageCountsMap.get(val.language_id) || 0,
											}));
										} else if (category === "Exam_Category") {
											const examCategoryCountsMap = new Map(examCategoryCounts.map(([exam_category_id, count]) => [exam_category_id, count]));
											filterItems = this.state.allExamCategories?.map((val) => ({
												filter: "Exam_Category",
												name: val.name,
												exam_category_id: val.exam_category_id,
												dynamic_count: examCategoryCountsMap.get(val.exam_category_id) || 0,
											}));
										}

										return (
											<div className="filterCard" key={index} style={{ display: "inline-block", minWidth: "300px", marginRight: "16px", maxHeight: "30vh" }}>
												<FormControlLabel
													label={category}
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: "flex-start",
														"& .MuiFormControlLabel-label": { fontWeight: "600" },
													}}
													control={
														<Checkbox
															checked={this.isParentChecked(category)}
															indeterminate={this.isParentIndeterminate(category)}
															onChange={() => this.handleParentCheckboxChange(category, filterItems)}
														/>
													}
												/>
												<Box sx={{ display: "flex", flexDirection: "column", ml: 3, maxHeight: "20vh", overflowY: "auto" }}>

													{filterItems?.map((item) => {

														const isChecked = this.state.filterValues.some((selectedItem) =>
															selectedItem.filter === item.filter &&
															selectedItem[`${item.filter.toLowerCase()}_id`] === item[`${item.filter.toLowerCase()}_id`]
														);

                                    return (
                                        <FormControlLabel
                                            key={item[`${category.toLowerCase()}_id`]}
                                            //label={`${item.name}`}
                                            label={`${item.name} ${item.dynamic_count !== 0 ? ` (${item.dynamic_count})` : ""}`}
                                            control={
                                                <Checkbox
                                                checked={isChecked}
                                                onChange={() => this.onSelectFilterMulti(item)}
                                                />
                                            }
                                        />
                                    )
                                    })}
                                </Box>
                            </div>
                            );
                            })}
                        </Box>
                            </Accordion>
                    </div> 
                    </div> */}
                {/* <div className="col-md-12 mt-5 mb-5">
                    {this.state.filterValues && this.state.filterValues.length > 0 && 
                        <PaperListChips
                            filterValues={this.state.filterValues}
                            chipClick={this.onSelectFilterMulti}
                            clearAll={this.clearAllFilters}
                        />
                    }
                </div> */}
            <div className="thepapers-wrapper">
                <div className="col-md-12 px-0">
                    <div className="row mt-6">
                    <div className="col-md-12 px-0 mb-4">
                        <PaperFilterLayout
                            userType={"DEOP"}
                            onFilterChange={this.handleFilterChange}
                            filterKeys={EMPLOYEE_FILTERS.ADMIN.ManageCreditCategories}
                            isShowExamStatus={false}
                        />
                    </div>  
                    <div className="col-md-12 transition-width">
            <div>
            <div className="row align-items-center mb-3">
            <div className="col-md-4 mb-2 mb-md-0 ">
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-0">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="w-100"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            </div>
            {/* <div className="col-md-3 mb-2 mb-md-0 d-flex justify-content-center">                       
                <span className="badge badge-custom" style={{ fontSize: '1rem' }}>
                        No of  Credits:{" "}
                         <strong>
                             {isTableDataLoading ? (<CircularProgress size={16} />) : (this.state.totalCredits)}
                             </strong>
                 </span>
             </div> */}
            </div>
            {isSpinnerLoading && (
                <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
                <div
                    className="loading-container"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "75vw",
                        height: "90vh",
                    }}
                >
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            ) : (credit_categories.length > 0 ? (
            <div style={{ width: "100%", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("credit_category_id")}
                    >
                        No{" "}
                        {this.state.sort_column === "credit_category_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("grade_id")}
                    >
                        Grade{" "}
                        {this.state.sort_column === "grade_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("subject_id")}
                    >
                        Subject{" "}
                        {this.state.sort_column === "subject_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("language_id")}
                    >
                        Language{" "}
                        {this.state.sort_column === "language_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("exam_category_id")}
                    >
                        Exam Category{" "}
                        {this.state.sort_column === "exam_category_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("purchase_method_id")}
                    >
                        Purchase Method{" "}
                        {this.state.sort_column === "purchase_method_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        >
                        No of credits {""}
                        
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        >
                        Price(Rs.){" "}
                   </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {credit_categories.map((creditCategoryItem) => (
                    <TableRow key={creditCategoryItem.price}>
                        <TableCell className="tData">
                          {creditCategoryItem.credit_category_id}
                        </TableCell>
                        <TableCell className="tData">
                          {"Grade" + " " + creditCategoryItem.grade}
                        </TableCell>
                        <TableCell className="tData">
                          {creditCategoryItem.subject}
                        </TableCell>
                        <TableCell className="tData">
                          {creditCategoryItem.language}
                        </TableCell>
                        <TableCell className="tData">
                          {creditCategoryItem.name}
                        </TableCell>
                        <TableCell className="tData">
                          {creditCategoryItem.purchase_method}
                        </TableCell>
                        <TableCell className="tData">
                          {creditCategoryItem.no_of_credits? creditCategoryItem.no_of_credits : "-"}
                        </TableCell>
                        <TableCell className="tData">
                          { creditCategoryItem.price=="0.0" ?  "-":creditCategoryItem.price}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                                <Button
                                    onClick={() => this.handleViewClick(creditCategoryItem)}
                                    className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                    title="View More Details"
                                />
                                {editVisibility && (
                                    <Button
                                        onClick={() =>
                                            this.toggleUpdateCreditCategoryModal(
                                                creditCategoryItem.credit_category_id,
                                                creditCategoryItem.grade_id,
                                                creditCategoryItem.subject_id,
                                                creditCategoryItem.language_id,
                                                creditCategoryItem.exam_category_id,
                                                creditCategoryItem.purchase_method_id,
                                                creditCategoryItem.status_id,
                                                creditCategoryItem.no_of_credits,
                                                creditCategoryItem.has_child_paper_credits,
                                                creditCategoryItem.child_paper_credits,
                                                creditCategoryItem.price,
                                                creditCategoryItem.price_currency_type_id,
                                                creditCategoryItem.status,
                                                creditCategoryItem.start_date,
                                                creditCategoryItem.end_date,
                                                false
                                            )
                                        }
                                        className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                        title="Edit Details"
                                    />
                                )}
                                {/* {deleteVisibility && (
                                    <Button
                                        onClick={() =>
                                            this.handleDeleteCreditCategory(
                                                creditCategoryItem.credit_category_id
                                            )
                                        }
                                        className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                        title="Delete"
                                    />
                                )} */}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalCreditCategories}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Credit Categories Available!</label>
            </div>
            ))}
            </div>
            </div>
                    </div> 
                </div>
            </div> 
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div style={{ position: 'relative' }}>
            {this.state.isSpinnerLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10,
                    borderRadius: '4px',
                }}>
                    <Spinner animation="border" variant="primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            )}
            <Modal.Header closeButton>
                <Modal.Title>Add Credit Category</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ filter: this.state.isSpinnerLoading ? 'blur(2px)' : 'none' }}>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Grade*</Form.Label>
                        <Form.Select
                            id="grade"
                            value={this.state.grade_id || ""}
                            onChange={this.handleChangeGrade}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allGrades.map((option, index) => (
                                <option key={index} value={option.grade_id}>
                                 {option.grade}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "grade",
                            this.state.grade_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Subject*</Form.Label>
                        <Form.Select
                            id="subject"
                            value={this.state.subject_id || ""}
                            onChange={this.handleChangeSubject}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allSubjects.map((option, index) => (
                                <option key={index} value={option.subject_id}>
                                 {option.subject}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "subject",
                            this.state.subject_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Language*</Form.Label>
                        <Form.Select
                            id="language"
                            value={this.state.language_id || ""}
                            onChange={this.handleChangeLanguage}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allLanguages.map((option, index) => (
                                <option key={index} value={option.language_id}>
                                 {option.language}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "language",
                            this.state.language_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Exam Category*</Form.Label>
                        <Form.Select
                            id="exam_category"
                            value={this.state.exam_category_id || ""}
                            onChange={this.handleChangeExamCategory}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allExamCategories.map((option, index) => (
                                <option key={index} value={option.exam_category_id}>
                                 {option.name}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "exam_category",
                            this.state.exam_category_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Purchase Method*</Form.Label>
                        <Form.Select
                            id="purchase_method_id"
                            value={this.state.purchase_method_id || ""}
                            onChange={this.handleChangePurchaseMethod}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allPurchaseMethods.map((option, index) => (
                                <option key={index} value={option.purchase_method_id}>
                                 {option.name}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "purchase_method_id",
                            this.state.purchase_method_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        aria-label="Default select example"
                        name="status"
                        onChange={this.handleChangeStatus}
                        value={this.state.status_id}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                        {this.state.allCreditCategoryStatuses.map((status) => (
                        <option key={status.status_id} value={status.status_id}>
                            {status.status}
                        </option>
                        ))}
                    </Form.Select>
                    <div style={{ color: "red" }}>
                        {this.validator.message("status", this.state.status_id, "required")}
                    </div>
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    {(parseInt(this.state.purchase_method_id) === 1 ||
                        parseInt(this.state.purchase_method_id) === 3) && (
                        <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>No of Credits*</Form.Label>

                        <Form.Control
                            placeholder="Enter no of credits..."
                            name="no_of_credits"
                            type="number"
                            value={this.state.no_of_credits || ""}
                            onChange={(e) => {
                            this.handleChange(e);
                            }}
                            min={0}
                        />

                        {this.state.no_of_credits_error && (
                            <div className="text-danger">
                            {this.state.no_of_credits_error}
                            </div>
                        )}

                        {this.validator.message(
                            "no_of_credits",
                            this.state.no_of_credits,
                            "required|number",
                            { className: "text-danger" }
                        )}

                        {parseInt(this.state.purchase_method_id) === 1 && (
                            <>
                            <div className="d-flex align-items-center mt-3">
                                <label
                                htmlFor="child-paper-credit"
                                className="mb-0 mr-2"
                                style={{
                                    cursor: "pointer",
                                    fontWeight: 500,
                                }}
                                >
                                Add credits for child papers
                                </label>

                                <Form.Check
                                    type="checkbox"
                                    id="child-paper-credit"
                                    inline
                                    checked={this.state.has_child_paper_credits || false}
                                    onChange={(e) =>
                                        this.setState({
                                        has_child_paper_credits: e.target.checked,
                                        child_paper_credits: e.target.checked
                                            ? this.state.child_paper_credits
                                            : "",
                                        })
                                    }
                                />
                            </div>

                            {this.state.has_child_paper_credits && (
                                <div className="mt-3">
                                <Form.Label>
                                    No of Child Paper Credits*
                                </Form.Label>

                                <Form.Control
                                    type="number"
                                    name="child_paper_credits"
                                    placeholder="Enter child paper credits..."
                                    value={this.state.child_paper_credits || ""}
                                    onChange={this.handleChange}
                                    min={0}
                                />

                                {this.state.child_paper_credits_error && (
                                    <div className="text-danger">
                                    {this.state.child_paper_credits_error}
                                    </div>
                                )}

                                {this.state.has_child_paper_credits &&
                                    this.validator.message(
                                        "child_paper_credits",
                                        this.state.child_paper_credits,
                                        "required|number",
                                        { className: "text-danger" }
                                )}
                                </div>
                            )}
                            </>
                        )}
                        </Form.Group>
                    )}

                    {(parseInt(this.state.purchase_method_id) === 2 ||
                        parseInt(this.state.purchase_method_id) === 3) && (
                        <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Price*</Form.Label>

                        <div className="d-flex align-items-center">
                            <Form.Control
                            type="number"
                            placeholder="Enter price value..."
                            name="price"
                            value={this.state.price || ""}
                            onChange={this.handleChange}
                            style={{ width: "70%", marginRight: "5px" }}
                            />

                            <Form.Select
                            id="currency_types"
                            value={this.state.price_currency_type_id || 1}
                            onChange={this.handleChangeCurrencyType}
                            className="form-control"
                            style={{ width: "30%" }}
                            >
                            {this.state.currencyTypes.map((option, index) => (
                                <option
                                key={index}
                                value={option.currency_type_id}
                                >
                                {option.name}
                                </option>
                            ))}
                            </Form.Select>
                        </div>

                        {this.state.price_error && (
                            <div className="text-danger">
                            {this.state.price_error}
                            </div>
                        )}

                        {this.validator.message(
                            "price",
                            this.state.price,
                            "required|number",
                            { className: "text-danger" }
                        )}
                        </Form.Group>
                    )}
                    </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Start Date*</Form.Label>
                        <Form.Control
                            type="date"
                            name="start_date"
                            value={this.state.start_date}
                            placeholder="start date"
                            onChange={this.handleChange}
                        />
                        <div style={{ color: "red" }}>
                        {this.validator.message(
                            "start_date",
                            this.state.start_date,
                            "required"
                        )}
                        </div>
                    </Form.Group>
                </Row>
                <Row className="my-5">
                <Form.Group as={Col} md="6" controlId="noEndDate">
                    <Form.Label>Do you want to have an end date?</Form.Label>
                    <CheckBoxInline style={{ alignItems: "center" }}>
                    <Form.Label
                        className="mb-0 mr-1"
                        style={{ fontWeight: "500" }}
                    >
                        Yes
                    </Form.Label>
                    <CheckBox
                        onChange={(e) => {
                        this.noEndDateSelected(e, true);
                        }}
                        checked={this.state.noEndDate}
                    />
                    <Form.Label
                        className="mb-0 mr-1"
                        style={{ fontWeight: "500" }}
                    >
                        No
                    </Form.Label>
                    <CheckBox
                        onChange={(e) => {
                        this.noEndDateSelected(e, false);
                        }}
                        checked={!this.state.noEndDate}
                    />
                    </CheckBoxInline>
                </Form.Group>

                {this.state.noEndDate && (
                    <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>End Date*</Form.Label>
                    <Form.Control
                        type="date"
                        name="end_date"
                        min={this.state.start_date}
                        value={this.state.end_date}
                        placeholder="end date"
                        onChange={this.handleChange}
                    />
                    <div style={{ color: "red" }}>
                        {this.state.endDateError || (this.state.noEndDate && this.validator.message(
                            "end_date",
                            this.state.end_date,
                            "required"
                        ))}
                    </div>
                    </Form.Group>
                )}
                </Row>
                </Form>
            </Modal.Body>

							<Modal.Footer style={{ filter: this.state.isSpinnerLoading ? 'blur(2px)' : 'none' }}>
								<Button
									variant="primary"
									style={addBtnStyle}
									onClick={this.handleSubmit}
									disabled={this.state.disabled || this.state.isSpinnerLoading}
								>
									Save changes
								</Button>
								<Button
									id="modal-close-button"
									style={closeBtnStyle}
									disabled={this.state.isSpinnerLoading}
									onClick={() =>
										this.handleSweetAlert(this.modalType, "showModal")
									}
								>
									Close
								</Button>
							</Modal.Footer>
						</div>
					) : (
						<div style={{ position: 'relative' }}>
                        {this.state.isSpinnerLoading && (
                            <div style={{
                                position: 'absolute',
                                top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                                borderRadius: '4px',
                            }}>
                                <Spinner animation="border" variant="primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            </div>
                        )}
							<Modal.Header closeButton>
								<Modal.Title>Update Credit Category</Modal.Title>
							</Modal.Header>
							<Modal.Body style={{ filter: this.state.isSpinnerLoading ? 'blur(2px)' : 'none' }}>
								<Form>
									{/* <Row className="my-5">
                <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Grade*</Form.Label>
                        <Form.Select
                            id="grade"
                            value={this.state.grade_id || ""}
                            onChange={this.handleChangeGrade}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allGrades.map((option, index) => (
                                <option key={index} value={option.grade_id}>
                                 {option.grade}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "grade",
                            this.state.grade_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Subject*</Form.Label>
                        <Form.Select
                            id="subject"
                            value={this.state.subject_id || ""}
                            onChange={this.handleChangeSubject}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allSubjects.map((option, index) => (
                                <option key={index} value={option.subject_id}>
                                 {option.subject}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "subject",
                            this.state.subject_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Language*</Form.Label>
                        <Form.Select
                            id="language"
                            value={this.state.language_id || ""}
                            onChange={this.handleChangeLanguage}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allLanguages.map((option, index) => (
                                <option key={index} value={option.language_id}>
                                 {option.language}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "language",
                            this.state.language_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Exam Category*</Form.Label>
                        <Form.Select
                            id="exam_category"
                            value={this.state.exam_category_id || ""}
                            onChange={this.handleChangeExamCategory}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allExamCategories.map((option, index) => (
                                <option key={index} value={option.exam_category_id}>
                                 {option.name}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "exam_category",
                            this.state.exam_category_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                </Row> */}
                <Row className="my-5">
                <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Select Purchase Method*</Form.Label>
                        <Form.Select
                            id="purchase_method_id"
                            value={this.state.purchase_method_id || ""}
                            onChange={this.handleChangePurchaseMethod}
                            className="form-control"
                            >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.allPurchaseMethods.map((option, index) => (
                                <option key={index} value={option.purchase_method_id}>
                                 {option.name}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "purchase_method_id",
                            this.state.purchase_method_id,
                            "required",
                            {
                                className: "text-danger",
                            }
                        )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        aria-label="Default select example"
                        name="status"
                        onChange={this.handleChangeStatus}
                        value={this.state.status_id}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                        {this.state.allCreditCategoryStatuses.map((status) => (
                        <option key={status.status_id} value={status.status_id}>
                            {status.status}
                        </option>
                        ))}
                    </Form.Select>
                    <div style={{ color: "red" }}>
                        {this.validator.message("status", this.state.status_id, "required")}
                    </div>
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    {(parseInt(this.state.purchase_method_id) === 1 ||
                        parseInt(this.state.purchase_method_id) === 3) && (
                        <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>No of Credits*</Form.Label>

                        <Form.Control
                            placeholder="Enter no of credits..."
                            name="no_of_credits"
                            type="number"
                            value={this.state.no_of_credits || ""}
                            onChange={(e) => {
                            this.handleChange(e);
                            }}
                            min={0}
                        />

                        {this.state.no_of_credits_error && (
                            <div className="text-danger">
                            {this.state.no_of_credits_error}
                            </div>
                        )}

                        {this.validator.message(
                            "no_of_credits",
                            this.state.no_of_credits,
                            "required|number",
                            { className: "text-danger" }
                        )}

                        {parseInt(this.state.purchase_method_id) === 1 && (
                            <>
                            <div className="d-flex align-items-center mt-3">
                                <label
                                htmlFor="child-paper-credit"
                                className="mb-0 mr-2"
                                style={{
                                    cursor: "pointer",
                                    fontWeight: 500,
                                }}
                                >
                                Add credits for child papers
                                </label>

                                <Form.Check
                                    type="checkbox"
                                    id="child-paper-credit"
                                    inline
                                    checked={this.state.has_child_paper_credits || false}
                                    onChange={(e) =>
                                        this.setState({
                                        has_child_paper_credits: e.target.checked,
                                        child_paper_credits: e.target.checked
                                            ? this.state.child_paper_credits
                                            : "",
                                        })
                                    }
                                />
                            </div>

                            {this.state.has_child_paper_credits && (
                                <div className="mt-3">
                                <Form.Label>
                                    No of Child Paper Credits*
                                </Form.Label>

                                <Form.Control
                                    type="number"
                                    name="child_paper_credits"
                                    placeholder="Enter child paper credits..."
                                    value={this.state.child_paper_credits || ""}
                                    onChange={this.handleChange}
                                    min={0}
                                />

                                {this.state.child_paper_credits_error && (
                                    <div className="text-danger">
                                    {this.state.child_paper_credits_error}
                                    </div>
                                )}

                                {this.state.has_child_paper_credits &&
                                    this.validator.message(
                                        "child_paper_credits",
                                        this.state.child_paper_credits,
                                        "required|number",
                                        { className: "text-danger" }
                                )}
                                </div>
                            )}
                            </>
                        )}
                        </Form.Group>
                    )}

                    {(parseInt(this.state.purchase_method_id) === 2 ||
                        parseInt(this.state.purchase_method_id) === 3) && (
                        <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Price*</Form.Label>

                        <div className="d-flex align-items-center">
                            <Form.Control
                            type="number"
                            placeholder="Enter price value..."
                            name="price"
                            value={this.state.price || ""}
                            onChange={this.handleChange}
                            style={{ width: "70%", marginRight: "5px" }}
                            />

                            <Form.Select
                            id="currency_types"
                            value={this.state.price_currency_type_id || 1}
                            onChange={this.handleChangeCurrencyType}
                            className="form-control"
                            style={{ width: "30%" }}
                            >
                            {this.state.currencyTypes.map((option, index) => (
                                <option
                                key={index}
                                value={option.currency_type_id}
                                >
                                {option.name}
                                </option>
                            ))}
                            </Form.Select>
                        </div>

                        {this.state.price_error && (
                            <div className="text-danger">
                            {this.state.price_error}
                            </div>
                        )}

                        {this.validator.message(
                            "price",
                            this.state.price,
                            "required|number",
                            { className: "text-danger" }
                        )}
                        </Form.Group>
                    )}
                    </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                        <Form.Label>Start Date*</Form.Label>
                        <Form.Control
                            type="date"
                            name="start_date"
                            value={this.state.start_date ? this.formatDateForInput(new Date(this.state.start_date)) : ""}
                            placeholder="start date"
                            onChange={this.handleChange}
                        />
                        <div style={{ color: "red" }}>
                        {this.validator.message(
                            "start_date",
                            this.state.start_date,
                            "required"
                        )}
                        </div>
                    </Form.Group>
                </Row>
                <Row className="my-5">
                <Form.Group as={Col} md="6" controlId="noEndDate">
                    <Form.Label>Do you want to have an end date?</Form.Label>
                    <CheckBoxInline style={{ alignItems: "center" }}>
                    <Form.Label
                        className="mb-0 mr-1"
                        style={{ fontWeight: "500" }}
                    >
                        Yes
                    </Form.Label>
                    <CheckBox
                        onChange={(e) => {
                        this.noEndDateSelected(e, true);
                        }}
                        checked={this.state.noEndDate}
                    />
                    <Form.Label
                        className="mb-0 mr-1"
                        style={{ fontWeight: "500" }}
                    >
                        No
                    </Form.Label>
                    <CheckBox
                        onChange={(e) => {
                        this.noEndDateSelected(e, false);
                        }}
                        checked={!this.state.noEndDate}
                    />
                    </CheckBoxInline>
                </Form.Group>

                {this.state.noEndDate && (
                    <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>End Date*</Form.Label>
                    <Form.Control
                        type="date"
                        name="end_date"
                        min={this.state.start_date ? this.formatDateForInput(new Date(this.state.start_date)) : ""}
                        value={this.state.end_date ? this.formatDateForInput(new Date(this.state.end_date)) : ""}
                        placeholder="end date"
                        onChange={this.handleChange}
                    />
                    <div style={{ color: "red" }}>
                        {this.state.endDateError || (this.state.noEndDate && this.validator.message(
                            "end_date",
                            this.state.end_date,
                            "required"
                        ))}
                    </div>
                    </Form.Group>
                )}
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{ filter: this.state.isSpinnerLoading ? 'blur(2px)' : 'none' }}>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                    disabled={this.state.disabled || this.state.isSpinnerLoading}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    disabled={this.state.isSpinnerLoading}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>

        <Modal
            size="lg"
            centered
            show={this.state.showDetailModal}
            onHide={this.toggleDetailModal}
        >
            <ModalHeader>
                <h5 className="modal-title">Credit Category Details</h5>
                <Button variant="secondary" onClick={this.toggleDetailModal}>
                    Close
                </Button>
            </ModalHeader>
            {this.state.selectedCreditCategory && (
                <ModalBody>
                    <ViewForm className="form" id="kt_form">
                        {this.state.selectedCreditCategory?.price !== "0.0" && parseInt(this.state.purchase_method_id) !== 3 &&
                            <>
                                <div className="row">
                                <h6 className="font-weight-bolder mb-3 col-md-4">
                                    Price :
                                </h6>
                                <div className="text-dark-50 line-height-lg col-md-5">
                                    <div className="inline-flex full-width align-center">
                                        {this.getCurrencyTypeSymbol(this.state.selectedCreditCategory?.price_currency_type_id) + " " + parseInt(this.state.selectedCreditCategory?.price)}
                                    </div>
                                </div>
                                </div>
                                <div className="separator separator-dashed my-5"></div>
                            </>
                        }     
                        {this.state.selectedCreditCategory?.no_of_credits !== 0 && parseInt(this.state.selectedCreditCategory?.purchase_method_id) !== 3 && (
                            <>
                                    <div className="row">
                                        <h6 className="font-weight-bolder mb-3 col-md-4">
                                            No of Credits :
                                        </h6>

                                        <div className="text-dark-50 line-height-lg col-md-5">
                                            <div className="inline-flex full-width align-center">
                                                {this.state.selectedCreditCategory?.no_of_credits}
                                            </div>
                                        </div>
                                    </div>

                                {this.state.selectedCreditCategory?.has_child_paper_credits && (
                                    <>
                                        <div className="separator separator-dashed my-5"></div>

                                        <div className="row">
                                            <h6 className="font-weight-bolder mb-3 col-md-4">
                                                Child Paper Credits :
                                            </h6>

                                            <div className="text-dark-50 line-height-lg col-md-5">
                                                <div className="inline-flex full-width align-center">
                                                    {this.state.selectedCreditCategory?.child_paper_credits}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="separator separator-dashed my-5"></div>
                            </>
                        )}
                        {this.state.selectedCreditCategory?.status !== null && 
                            <>
                                <div className="row">
                                <h6 className="font-weight-bolder mb-3 col-md-4">
                                    Status :
                                </h6>
                                <div className="text-dark-50 line-height-lg col-md-5">
                                    <div className="inline-flex full-width align-center">
                                        <span className={this.getColor(this.state.selectedCreditCategory?.status)}>
                                            {this.state.selectedCreditCategory?.status}
                                        </span>
                                    </div>
                                </div>
                                </div>
                            </>
                        } 
                        {this.state.selectedCreditCategory?.start_date !== null && 
                            <>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="row">
                                <h6 className="font-weight-bolder mb-3 col-md-4">
                                    Start Date :
                                </h6>
                                <div className="text-dark-50 line-height-lg col-md-5">
                                    <div className="inline-flex full-width align-center">
                                        {new Date(this.convertTimeLevel(this.state.selectedCreditCategory?.start_date)).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                    </div>
                                </div>
                                </div>
                            </>
                        } 
                        {this.state.selectedCreditCategory?.end_date !== null && 
                            <>
                                <div className="separator separator-dashed my-5"></div>
                                <div className="row">
                                <h6 className="font-weight-bolder mb-3 col-md-4">
                                    End Date :
                                </h6>
                                <div className="text-dark-50 line-height-lg col-md-5">
                                    <div className="inline-flex full-width align-center">
                                        {new Date(this.convertTimeLevel(this.state.selectedCreditCategory?.end_date)).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                        })}
                                    </div>
                                </div>
                                </div>
                            </>
                        }         
                    </ViewForm>
                </ModalBody>
            )}
        </Modal>
    </>
    );
}
}

export default ManageCreditCategories;
